import React from "react";
import Grid from "@mui/material/Grid";
import {ChangePasswordCard} from "components/Shared";

const ChangePassword = () => (
  <Grid container spacing={2} justifyContent="center">
    <Grid item xs={4}>
      <ChangePasswordCard/>
    </Grid>
  </Grid>
);

export default ChangePassword;
